// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles */
body {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
  background-color: #f8fafc;
}

#root {
  min-height: 100vh;
}

/* Button Animations - Glean Style */
@keyframes buttonGlow {
  0%, 100% {
    box-shadow: 0 0 20px rgba(14, 165, 233, 0.3), 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
  50% {
    box-shadow: 0 0 30px rgba(14, 165, 233, 0.5), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

@keyframes buttonPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

@keyframes arrowSlide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(4px);
  }
}

@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

/* Primary Button Styles */
.btn-primary {
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(0);
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn-primary:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 10px 25px rgba(14, 165, 233, 0.4), 0 0 40px rgba(14, 165, 233, 0.3);
}

.btn-primary:active {
  transform: translateY(0) scale(0.98);
}

.btn-primary:hover::before {
  width: 300px;
  height: 300px;
}

.btn-primary .arrow-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.btn-primary:hover .arrow-icon {
  transform: translateX(4px);
}

/* Secondary Button Styles */
.btn-secondary {
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(0);
}

.btn-secondary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s;
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  border-color: rgba(148, 163, 184, 0.8);
}

.btn-secondary:hover::before {
  left: 100%;
}

.btn-secondary:active {
  transform: translateY(0);
}

/* CTA Button in Nav */
.btn-nav-cta {
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-nav-cta::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.4s, height 0.4s;
}

.btn-nav-cta:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(14, 165, 233, 0.4);
}

.btn-nav-cta:hover::after {
  width: 200px;
  height: 200px;
}

/* Link with Arrow Animation */
.link-with-arrow {
  display: inline-flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.link-with-arrow .arrow-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.link-with-arrow:hover {
  transform: translateX(2px);
}

.link-with-arrow:hover .arrow-icon {
  transform: translateX(4px);
}

/* Smooth scale animation for cards */
.card-hover {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-hover:hover {
  transform: translateY(-4px);
}

/* Gradient text animation */
@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.gradient-text {
  background-size: 200% 200%;
  animation: gradientShift 3s ease infinite;
}

`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE;IACE,+EAA+E;EACjF;EACA;IACE,iFAAiF;EACnF;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uDAAuD;EACvD,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,uDAAuD;EACvD,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C","sourcesContent":["/* Global styles */\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Inter', sans-serif;\r\n  background-color: #f8fafc;\r\n}\r\n\r\n#root {\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Button Animations - Glean Style */\r\n@keyframes buttonGlow {\r\n  0%, 100% {\r\n    box-shadow: 0 0 20px rgba(14, 165, 233, 0.3), 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 30px rgba(14, 165, 233, 0.5), 0 10px 15px -3px rgba(0, 0, 0, 0.1);\r\n  }\r\n}\r\n\r\n@keyframes buttonPulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.02);\r\n  }\r\n}\r\n\r\n@keyframes arrowSlide {\r\n  0% {\r\n    transform: translateX(0);\r\n  }\r\n  100% {\r\n    transform: translateX(4px);\r\n  }\r\n}\r\n\r\n@keyframes ripple {\r\n  0% {\r\n    transform: scale(0);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: scale(4);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* Primary Button Styles */\r\n.btn-primary {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn-primary::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.2);\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.6s, height 0.6s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  transform: translateY(-2px) scale(1.02);\r\n  box-shadow: 0 10px 25px rgba(14, 165, 233, 0.4), 0 0 40px rgba(14, 165, 233, 0.3);\r\n}\r\n\r\n.btn-primary:active {\r\n  transform: translateY(0) scale(0.98);\r\n}\r\n\r\n.btn-primary:hover::before {\r\n  width: 300px;\r\n  height: 300px;\r\n}\r\n\r\n.btn-primary .arrow-icon {\r\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  display: inline-block;\r\n}\r\n\r\n.btn-primary:hover .arrow-icon {\r\n  transform: translateX(4px);\r\n}\r\n\r\n/* Secondary Button Styles */\r\n.btn-secondary {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  transform: translateY(0);\r\n}\r\n\r\n.btn-secondary::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\r\n  transition: left 0.5s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\r\n  border-color: rgba(148, 163, 184, 0.8);\r\n}\r\n\r\n.btn-secondary:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.btn-secondary:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* CTA Button in Nav */\r\n.btn-nav-cta {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.btn-nav-cta::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.3);\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.4s, height 0.4s;\r\n}\r\n\r\n.btn-nav-cta:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: 0 8px 20px rgba(14, 165, 233, 0.4);\r\n}\r\n\r\n.btn-nav-cta:hover::after {\r\n  width: 200px;\r\n  height: 200px;\r\n}\r\n\r\n/* Link with Arrow Animation */\r\n.link-with-arrow {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.link-with-arrow .arrow-icon {\r\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  display: inline-block;\r\n}\r\n\r\n.link-with-arrow:hover {\r\n  transform: translateX(2px);\r\n}\r\n\r\n.link-with-arrow:hover .arrow-icon {\r\n  transform: translateX(4px);\r\n}\r\n\r\n/* Smooth scale animation for cards */\r\n.card-hover {\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.card-hover:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n/* Gradient text animation */\r\n@keyframes gradientShift {\r\n  0%, 100% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n}\r\n\r\n.gradient-text {\r\n  background-size: 200% 200%;\r\n  animation: gradientShift 3s ease infinite;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
